export default __webpack_public_path__ + "static/media/Aura-Egg__14.5c30a789.png";